import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './styles/dropdowns.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { apiCall } from './config/api';

// Set up fetch interceptor to route all API calls to MockAPI
const originalFetch = window.fetch;
window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;

  // IMPORTANT: Don't intercept /api/waitlist - it should use the real Vercel serverless function
  if (url.includes('/api/waitlist')) {
    return originalFetch(input, init);
  }

  // Only intercept demo.local and localhost API calls
  if (url.includes('demo.local') || url.includes('localhost') || url.includes('/api/')) {
    try {
      const data = await apiCall(url, init || {});
      // Return a mock Response object
      return new Response(JSON.stringify(data), {
        status: 200,
        statusText: 'OK',
        headers: { 'Content-Type': 'application/json' },
      });
    } catch (error: any) {
      // Return error as mock Response
      return new Response(JSON.stringify({ error: error.message || 'Request failed' }), {
        status: error.status || 500,
        statusText: 'Error',
        headers: { 'Content-Type': 'application/json' },
      });
    }
  }

  // For all other requests, use original fetch
  return originalFetch(input, init);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
